// "Meer inspiratie" in de chat: de dertien vragen die de owner op 14-10 koos
// (ronde 6), in zijn volgorde. Eerder stonden hier de 44 vragen van de
// chattoets per soort; die blijven in tests/golden/chat/vragen.jsonl.

export const CHAT_INSPIRATIE: readonly string[] = [
  "Welke vaardigheden vraagt de komst van de EU AI Act van medewerkers?",
  "Stel een top-10 aan leerdoelen samen voor een keuzedeel 'AI in de praktijk', gebaseerd op de hoogst geprioriteerde vaardigheden.",
  "Welke vaardigheden moet een mbo-systeembeheerder erbij leren door de Cyberbeveiligingswet?",
  "Welke opkomende vaardigheden zijn er rond cloud?",
  "Welke bronnen van na 1 januari 2026 gaan over AI-vaardigheden?",
  "Ik wil alleen ontwikkelingen zien die onderbouwd zijn door bronnen met een gezagscijfer van 8 of hoger.",
  "Welke arbeidsmarktobservaties gaan over de ICT-sector in onze eigen regio?",
  "Wat zijn de beste quick wins die ik een klant morgen kan adviseren?",
  "Welke trend heeft nu de hoogste uitlichtscore, en waarom staat die bovenaan?",
  "Welke vaardigheid wordt door de meeste trends gevraagd?",
  "Wat zegt de arbeidsmarktdata over de vraag naar mbo-geschoolde ICT'ers, tegenover hbo?",
  "Wat is de vervangingsvraag voor ICT-beroepen de komende jaren?",
  "Waar zit het grootste gat tussen wat de markt vraagt en wat wij nu aanbieden?",
];

// Dezelfde vragen in trendlaagwoorden (trendlaag ronde 3, alleen met de
// schakelaar aan): geen gezagscijfer en geen uitlichtscore meer, wel trends,
// ontwikkelingen en bevindingen. Volgorde en aantal gelijk aan de lijst hierboven.
export const CHAT_INSPIRATIE_TRENDLAAG: readonly string[] = [
  "Welke vaardigheden vraagt de komst van de EU AI Act van medewerkers?",
  "Stel een top-10 aan leerdoelen samen voor een keuzedeel 'AI in de praktijk', gebaseerd op de hoogst geprioriteerde vaardigheden.",
  "Welke vaardigheden moet een mbo-systeembeheerder erbij leren door de Cyberbeveiligingswet?",
  "Welke opkomende ontwikkelingen zijn er rond cloud?",
  "Welke bronnen van na 1 januari 2026 gaan over AI-vaardigheden?",
  "Welke ontwikkelingen rusten op de meeste verschillende bronnen?",
  "Welke arbeidsmarktobservaties gaan over de ICT-sector in onze eigen regio?",
  "Wat zijn de beste quick wins die ik een klant morgen kan adviseren?",
  "Welke trend staat nu bovenaan, en op welke ontwikkelingen rust die?",
  "Hoeveel bevindingen, ontwikkelingen en trends gaan over AI?",
  "Wat zegt de arbeidsmarktdata over de vraag naar mbo-geschoolde ICT'ers, tegenover hbo?",
  "Welke ontwikkelingen in wet- en regelgeving hebben een datum waarop ze ingaan?",
  "Waar zit het grootste gat tussen wat de markt vraagt en wat wij nu aanbieden?",
];

// Pilot gereed 26-10 (baan 1C): de dertien hierboven zijn ICT-vragen (AI Act,
// Cyberbeveiligingswet, cloud, ICT'ers). Een gebruiker die op een
// pilotpropositie staat krijgt een sectorneutrale set in gewone taal; de
// propositie zelf zit al in de chat (die zoekt binnen de eigen sector).
export const CHAT_INSPIRATIE_ALGEMEEN: readonly string[] = [
  "Welke ontwikkelingen veranderen het werk in onze sector het meest?",
  "Welke vaardigheden worden de komende jaren belangrijker voor onze studenten?",
  "Stel een top-10 aan leerdoelen samen voor een keuzedeel, gebaseerd op de hoogst geprioriteerde vaardigheden.",
  "Welke nieuwe wet- of regelgeving raakt het werk in onze sector?",
  "Welke bronnen van na 1 januari 2026 gaan over nieuwe vaardigheden?",
  "Welke trend heeft nu de hoogste uitlichtscore, en waarom staat die bovenaan?",
  "Welke vaardigheid wordt door de meeste trends gevraagd?",
  "Wat zegt de arbeidsmarktdata over de vraag naar mbo'ers in onze sector?",
  "Welke arbeidsmarktobservaties gaan over onze eigen regio?",
  "Wat zijn de beste quick wins die ik een klant morgen kan adviseren?",
  "Waar zit het grootste gat tussen wat de markt vraagt en wat wij nu aanbieden?",
];

// De sectorneutrale set in trendlaagwoorden (schakelaar aan): geen
// uitlichtscore, wel trends en ontwikkelingen. Volgorde en aantal gelijk.
export const CHAT_INSPIRATIE_ALGEMEEN_TRENDLAAG: readonly string[] = [
  "Welke ontwikkelingen veranderen het werk in onze sector het meest?",
  "Welke vaardigheden worden de komende jaren belangrijker voor onze studenten?",
  "Stel een top-10 aan leerdoelen samen voor een keuzedeel, gebaseerd op de hoogst geprioriteerde vaardigheden.",
  "Welke nieuwe wet- of regelgeving raakt het werk in onze sector?",
  "Welke bronnen van na 1 januari 2026 gaan over nieuwe vaardigheden?",
  "Welke trend staat nu bovenaan, en op welke ontwikkelingen rust die?",
  "Welke ontwikkelingen rusten op de meeste verschillende bronnen?",
  "Wat zegt de arbeidsmarktdata over de vraag naar mbo'ers in onze sector?",
  "Welke arbeidsmarktobservaties gaan over onze eigen regio?",
  "Wat zijn de beste quick wins die ik een klant morgen kan adviseren?",
  "Waar zit het grootste gat tussen wat de markt vraagt en wat wij nu aanbieden?",
];

/** De inspiratievragen voor de sector waar de schermen op staan: ICT houdt de
 *  dertien van de owner, elke andere sector de sectorneutrale set; met de
 *  trendlaag aan elk in trendlaagwoorden. */
export function inspiratieVoor(sector: string | null | undefined, trendlaag = false): readonly string[] {
  if (!sector || sector === "ict") return trendlaag ? CHAT_INSPIRATIE_TRENDLAAG : CHAT_INSPIRATIE;
  return trendlaag ? CHAT_INSPIRATIE_ALGEMEEN_TRENDLAAG : CHAT_INSPIRATIE_ALGEMEEN;
}
